import { numberToFixed } from "utils/number";
import { formatAspect } from "utils/playground/banner";
import { TActState, TBannerItem } from "views/services/banner";

export const formatBannerGridSize = (banner: TBannerItem, gridWidth: number) => {
	const bannerWidth = formatAspect(banner.width || "");
	gridWidth = Math.max(gridWidth, bannerWidth);
	const bannerHeight = formatAspect(banner.height || "");

	const aspectRatio = bannerWidth ? numberToFixed(+bannerHeight / bannerWidth) : 0;

	return {
		width: gridWidth,
		height: +numberToFixed(+aspectRatio * gridWidth),
		aspectRatio: +aspectRatio,
	};
};

export const isValidState = (state: TActState) => {
	return [TActState.ComingSoon, TActState.OnGoing].includes(state);
};
export const isUnValidState = (state: TActState) => {
	return [TActState.UnkonwnActState, TActState.Ended].includes(state);
};
